import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "name" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "p-error"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { for: "description" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "p-field p-col-6" }
const _hoisted_11 = { for: "dataType" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field p-col-6" }
const _hoisted_14 = { for: "externalName" }
const _hoisted_15 = { class: "p-field p-col-6" }
const _hoisted_16 = { for: "headerLocatorId" }
const _hoisted_17 = { class: "p-field p-col-6" }
const _hoisted_18 = { for: "valueLocatorId" }
const _hoisted_19 = { class: "p-field p-col-3" }
const _hoisted_20 = { for: "mandatory" }
const _hoisted_21 = { class: "p-field p-col-3" }
const _hoisted_22 = { for: "readonly" }
const _hoisted_23 = { class: "p-field p-col-3" }
const _hoisted_24 = { for: "hidden" }
const _hoisted_25 = { class: "p-field p-col-3" }
const _hoisted_26 = { for: "forceValidation" }
const _hoisted_27 = { class: "p-field p-col-6" }
const _hoisted_28 = { for: "maxlength" }
const _hoisted_29 = { class: "p-field p-col-6" }
const _hoisted_30 = { for: "truncateType" }
const _hoisted_31 = { class: "p-field p-col-6" }
const _hoisted_32 = { for: "width" }
const _hoisted_33 = {
  key: 0,
  class: "p-error"
}
const _hoisted_34 = { class: "p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DexInputText = _resolveComponent("DexInputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_AmountSeparatorsForm = _resolveComponent("AmountSeparatorsForm")!
  const _component_DbLookupForm = _resolveComponent("DbLookupForm")!
  const _component_LookupColumnFiltersView = _resolveComponent("LookupColumnFiltersView")!
  const _component_PromptListView = _resolveComponent("PromptListView")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createBlock(_component_TabView, {
    onTabChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onTabChange($event.index)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabPanel, {
        header: _ctx.$t('Squeeze.DocumentClasses.FieldAttributes')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Name')) + " *", 1),
              _createVNode(_component_InputText, {
                id: "name",
                modelValue: _ctx.v$.name.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                modelModifiers: { trim: true },
                class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeInput,
                required: "true",
                autofocus: ""
              }, null, 8, ["modelValue", "class", "onChange"]),
              (_ctx.v$.name.required.$invalid && _ctx.showErrorMessage && !_ctx.v$.name.technicalValidation.$invalid)
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
                : _createCommentVNode("", true),
              (_ctx.v$.name.technicalValidation.$invalid && _ctx.showErrorMessage)
                ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowAlphaNumericUnderscore', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
                : (!!_ctx.value.id)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Admin.WarnRename')), 1))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')) + " *", 1),
              _createVNode(_component_DexInputText, {
                id: "description",
                modelValue: _ctx.v$.description.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
                modelModifiers: { trim: true },
                translatedDescription: _ctx.value.translatedDescription,
                translationKey: _ctx.value.translationKey,
                class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeInput,
                required: "true"
              }, null, 8, ["modelValue", "translatedDescription", "translationKey", "class", "onChange"]),
              ((_ctx.v$.description.$invalid && _ctx.showErrorMessage))
                ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Description')})), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DataType')) + " *", 1),
              _createVNode(_component_Dropdown, {
                id: "dataType",
                modelValue: _ctx.v$.dataType.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.dataType.$model) = $event)),
                options: _ctx.dataTypes,
                class: _normalizeClass({'p-invalid':!_ctx.v$.dataType.$model && _ctx.showErrorMessage}),
                optionValue: "id",
                optionLabel: "text",
                onChange: _ctx.onChangeDataType
              }, null, 8, ["modelValue", "options", "class", "onChange"]),
              ((!_ctx.v$.dataType.$model && _ctx.showErrorMessage))
                ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.DataType')})), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ExternalName')), 1),
              _createVNode(_component_InputText, {
                id: "externalName",
                modelValue: _ctx.value.externalName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.externalName) = $event)),
                modelModifiers: { trim: true },
                required: "true"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.HeaderLocator')), 1),
              _createVNode(_component_Dropdown, {
                id: "headerLocatorId",
                modelValue: _ctx.value.headerLocatorId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.headerLocatorId) = $event)),
                options: _ctx.locators,
                filter: true,
                autoFilterFocus: true,
                optionValue: "id",
                optionLabel: _ctx.getTranslatedDescription,
                showClear: true,
                editable: false,
                onShow: _ctx.showDropdownOverlay
              }, null, 8, ["modelValue", "options", "optionLabel", "onShow"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ValueLocator')), 1),
              _createVNode(_component_Dropdown, {
                id: "valueLocatorId",
                modelValue: _ctx.value.valueLocatorId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.valueLocatorId) = $event)),
                options: _ctx.locators,
                filter: true,
                autoFilterFocus: true,
                optionValue: "id",
                optionLabel: _ctx.getTranslatedDescription,
                showClear: true,
                editable: false,
                onShow: _ctx.showDropdownOverlay
              }, null, 8, ["modelValue", "options", "optionLabel", "onShow"])
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "p-field p-col-12" }, null, -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Mandatory')), 1),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_Checkbox, {
                id: "mandatory",
                modelValue: _ctx.value.mandatory,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.mandatory) = $event)),
                binary: true,
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeCheckBox('mandatory')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ReadOnly')), 1),
              _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_Checkbox, {
                id: "readonly",
                modelValue: _ctx.value.readonly,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.value.readonly) = $event)),
                binary: true,
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeCheckBox('readonly')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Hidden')), 1),
              _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_Checkbox, {
                id: "hidden",
                modelValue: _ctx.value.hidden,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.value.hidden) = $event)),
                binary: true,
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangeCheckBox('hidden')))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ForceValidation')), 1),
              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_Checkbox, {
                id: "forceValidation",
                modelValue: _ctx.value.forceValidation,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.value.forceValidation) = $event)),
                binary: true,
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onChangeCheckBox('forceValidation')))
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.value.dataType === 'Text')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.FieldLength')), 1),
                    _createVNode(_component_InputNumber, {
                      id: "maxlength",
                      modelValue: _ctx.value.maxlength,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.value.maxlength) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.CutContent')), 1),
                    _createVNode(_component_Dropdown, {
                      id: "truncateType",
                      modelValue: _ctx.value.truncateType,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.value.truncateType) = $event)),
                      options: _ctx.truncateTypes,
                      optionValue: "id",
                      optionLabel: "text",
                      onShow: _ctx.showDropdownOverlay,
                      disabled: _ctx.value.maxlength < 1
                    }, null, 8, ["modelValue", "options", "onShow", "disabled"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.TableColumnWidth')), 1),
              _createVNode(_component_InputText, {
                id: "width",
                modelValue: _ctx.v$.width.$model,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.width.$model) = $event)),
                modelModifiers: { trim: true },
                class: _normalizeClass({'p-invalid':_ctx.v$.width.$invalid && _ctx.showErrorMessage}),
                onChange: _ctx.onChangeInput,
                required: "true"
              }, null, 8, ["modelValue", "class", "onChange"]),
              (_ctx.v$.width.stringWithNumbersValidation.$invalid && _ctx.showErrorMessage)
                ? (_openBlock(), _createElementBlock("small", _hoisted_33, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowNumeric', { field: _ctx.$t('Squeeze.DocumentClasses.TableColumnWidth')})), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      (_ctx.store.state.featureSet.configurableFieldAmountFormatting)
        ? (_openBlock(), _createBlock(_component_TabPanel, {
            key: 0,
            disabled: !_ctx.value.dataType || _ctx.value.dataType !== 'Amount',
            header: _ctx.$t('Squeeze.General.Presentation')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AmountSeparatorsForm, {
                amountSeparatorData: {thousandSeparator: _ctx.value.thousandSeparator, decimalSeparator: _ctx.value.decimalSeparator, decimalPlaces: _ctx.value.decimalPlaces},
                onUpdate: _ctx.onChangeAmountSeparators
              }, null, 8, ["amountSeparatorData", "onUpdate"])
            ]),
            _: 1
          }, 8, ["disabled", "header"]))
        : _createCommentVNode("", true),
      _createVNode(_component_TabPanel, {
        disabled: !_ctx.value.dataType || _ctx.value.dataType !== 'Text',
        header: _ctx.$t('Squeeze.DocumentClasses.DbLookup')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DbLookupForm, {
            dbLookUpEntry: _ctx.value.lookup,
            showErrorMessage: _ctx.showErrorMessage,
            onUpdate: _ctx.onUpdateTableLookup
          }, null, 8, ["dbLookUpEntry", "showErrorMessage", "onUpdate"]),
          (_ctx.value.id && _ctx.value.lookup.active)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.FieldFilterInfo')), 1),
                _createVNode(_component_LookupColumnFiltersView, {
                  "document-class-id": _ctx.documentClassId,
                  "tab-id": _ctx.columnEntry.tableId,
                  "field-id": _ctx.columnEntry.id,
                  "table-id": _ctx.columnEntry.lookup.tableId,
                  tableColumns: _ctx.tableColumns
                }, null, 8, ["document-class-id", "tab-id", "field-id", "table-id", "tableColumns"])
              ], 64))
            : (_ctx.value.lookup.active)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.t('Squeeze.DocumentClasses.PleaseSaveFieldFirst')), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled", "header"]),
      (_ctx.showPromptsTab)
        ? (_openBlock(), _createBlock(_component_TabPanel, {
            key: 1,
            disabled: !_ctx.value.id,
            header: _ctx.$t('Squeeze.Prompts.Prompts')
          }, {
            default: _withCtx(() => [
              (_ctx.value.id)
                ? (_openBlock(), _createBlock(_component_PromptListView, {
                    key: 0,
                    contextDocumentClassId: _ctx.documentClassId,
                    contextFieldName: _ctx.value.name,
                    contextHasLlmClass: _ctx.llmExtractionActive,
                    lineItem: true
                  }, null, 8, ["contextDocumentClassId", "contextFieldName", "contextHasLlmClass"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.PleaseSaveFieldFirst')), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled", "header"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}